import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { CircularProgress, Box } from "@mui/material";

export default function PostLoginRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/mi-dashboard", { replace: true });
  }, [navigate]);

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <CircularProgress />
    </Box>
  );
}
